/*
 * @Author: Gang Jiang 
 * @Date: 2024-10-12 13:46:55 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2024-10-14 15:05:57
 */

export default {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      // Check if the click is outside the element
      if (!el.contains(event.target)) {
        binding.value(event);
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener('click', el.clickOutsideEvent);
  },
};
